{
  "profile.avatar.alt": "Avatar for {name}",
  "profile.avatar.change": "Choose avatar",
  "profile.avatar.description": "JPEG, PNG, or WebP up to 5 MB. The avatar updates immediately after upload.",
  "profile.avatar.invalid": "Choose a JPEG, PNG, or WebP image up to 5 MB.",
  "profile.avatar.label": "Profile avatar",
  "profile.avatar.no_image": "No avatar set",
  "profile.avatar.progress": "Avatar upload progress: {percent}%",
  "profile.avatar.submit": "Upload avatar",
  "profile.avatar.success": "Your avatar has been updated.",
  "profile.avatar.upload_error": "Avatar upload failed. Choose the file again and retry.",
  "profile.basic.description": "Manage your display information, language, and time zone preferences.",
  "profile.connections.account_hint": "Account hint: {hint}",
  "profile.connections.action_error": "The connected-account operation failed. Try again.",
  "profile.connections.bind": "Connect account",
  "profile.connections.bound_at": "Connected: {date}",
  "profile.connections.connected": "Connected",
  "profile.connections.description": "Manage third-party identities connected to this account. Provider tokens and raw account identifiers are never displayed.",
  "profile.connections.empty": "No third-party accounts are connected yet.",
  "profile.connections.feature_disabled": "Third-party account connections are not enabled.",
  "profile.connections.load_error": "Connected accounts could not be loaded. Try again.",
  "profile.connections.not_connected": "Not connected",
  "profile.connections.provider_description": "Connect an account through an approved OAuth adapter.",
  "profile.connections.providers.local": "Local OAuth simulator",
  "profile.connections.unbind": "Disconnect",
  "profile.connections.unbind_confirm": "This identity can no longer be used with the current account. Confirm that password or multi-factor sign-in remains available.",
  "profile.connections.unbind_success": "The third-party account was disconnected.",
  "profile.connections.unbind_title": "Disconnect this third-party account?",
  "profile.devices.active_sessions": "Active sessions",
  "profile.devices.confirm_current": "Removing this current device will revoke all of its sessions and sign you out immediately. Continue?",
  "profile.devices.confirm_other": "Remove this device? All sessions associated with it will be revoked.",
  "profile.devices.created_at": "First registered",
  "profile.devices.current": "Current device",
  "profile.devices.description": "Manage Web devices associated with your Admin account. Removing a device revokes all of its sessions.",
  "profile.devices.empty": "There are no registered devices. A device will be registered the next time you sign in from a supported browser.",
  "profile.devices.ip_address": "Latest IP address",
  "profile.devices.last_seen_at": "Last active",
  "profile.devices.load_error": "Could not load registered devices. Try again.",
  "profile.devices.platform.web": "Web",
  "profile.devices.remove": "Remove device",
  "profile.devices.remove_error": "Could not remove the device. Try again.",
  "profile.devices.remove_success": "The device was removed and its sessions were revoked.",
  "profile.devices.remove_title": "Confirm device removal",
  "profile.devices.title": "Registered devices",
  "profile.devices.unknown": "Unknown device",
  "profile.fields.display_name": "Display name",
  "profile.fields.email": "Sign-in email",
  "profile.fields.locale": "Language",
  "profile.fields.time_zone": "Time zone",
  "profile.language.save_error": "Not saved. Try again.",
  "profile.language.title": "Display language",
  "profile.load_error": "Could not load your profile settings. Try again.",
  "profile.mfa.action_error": "The multi-factor authentication operation failed. Check the verification details and try again.",
  "profile.mfa.authenticator": "Authenticator",
  "profile.mfa.code_invalid": "Enter the 6-digit code from your authenticator.",
  "profile.mfa.code_label": "6-digit code",
  "profile.mfa.description": "Protect this account with an authenticator and one-time recovery codes.",
  "profile.mfa.disable": "Disable",
  "profile.mfa.disable_success": "Multi-factor authentication is disabled.",
  "profile.mfa.disable_title": "Disable multi-factor authentication",
  "profile.mfa.disabled": "Not enabled",
  "profile.mfa.enabled": "Enabled",
  "profile.mfa.enroll": "Set up authenticator",
  "profile.mfa.enrollment_title": "Set up authenticator",
  "profile.mfa.load_error": "Multi-factor authentication status could not be loaded. Try again.",
  "profile.mfa.recovery_ack": "I saved the recovery codes in a secure location",
  "profile.mfa.recovery_once": "These recovery codes are shown once. Each code can be used only once.",
  "profile.mfa.recovery_remaining": "{count} recovery codes remaining",
  "profile.mfa.recovery_title": "One-time recovery codes",
  "profile.mfa.rotate_codes": "Regenerate recovery codes",
  "profile.mfa.rotate_title": "Regenerate recovery codes",
  "profile.mfa.saved_codes": "I saved them securely",
  "profile.mfa.secret_label": "One-time setup secret",
  "profile.mfa.secret_once": "The secret and setup URI are shown once. Do not save them in screenshots or unsafe locations.",
  "profile.mfa.step_up.password": "Current password",
  "profile.mfa.step_up.totp": "Authenticator code",
  "profile.mfa.step_up_invalid": "Enter valid verification details.",
  "profile.mfa.step_up_method": "Verification method",
  "profile.mfa.step_up_notice": "This sensitive action requires identity verification.",
  "profile.mfa.step_up_proof": "Verification details",
  "profile.mfa.title": "Multi-factor authentication",
  "profile.mfa.verify": "Verify and enable",
  "profile.navigation.basic": "Basic settings",
  "profile.navigation.connections": "Connected accounts",
  "profile.navigation.security": "Security settings",
  "profile.oauth_callback.error": "The third-party account could not be connected",
  "profile.oauth_callback.error_description": "The connection request is invalid, expired, or already used. Return and start again.",
  "profile.oauth_callback.processing": "Securely completing the account connection…",
  "profile.oauth_callback.return": "Return to connected accounts",
  "profile.oauth_callback.success": "Third-party account connected",
  "profile.oauth_callback.success_description": "{provider} is connected and authorization parameters were removed from the address bar.",
  "profile.password.confirm": "Confirm new password",
  "profile.password.current": "Current password",
  "profile.password.current_invalid": "The current password is incorrect.",
  "profile.password.description": "Changing your password keeps this session and revokes your other Admin sessions.",
  "profile.password.error": "Could not change your password. Try again.",
  "profile.password.mismatch": "The new passwords do not match.",
  "profile.password.new": "New password",
  "profile.password.requirements": "Use 12–256 characters and a password different from your current and recently used passwords.",
  "profile.password.reused": "The new password must differ from your current and recently used passwords.",
  "profile.password.submit": "Change password",
  "profile.password.success": "Your password has been changed and other Admin sessions were revoked.",
  "profile.password.title": "Change password",
  "profile.save_error": "Could not save your profile settings. Try again.",
  "profile.save_success": "Your profile settings have been saved.",
  "profile.security.description": "Review and manage active Admin sessions for your account.",
  "profile.sessions.absolute_expires_at": "Session expires",
  "profile.sessions.confirm_current": "Revoking this current session will sign you out immediately. Continue?",
  "profile.sessions.confirm_other": "Revoke this session? It will no longer be able to access Admin.",
  "profile.sessions.created_at": "Signed in",
  "profile.sessions.current": "Current session",
  "profile.sessions.empty": "There are no active sessions.",
  "profile.sessions.ip_address": "IP address",
  "profile.sessions.last_seen_at": "Last active",
  "profile.sessions.load_error": "Could not load active sessions. Try again.",
  "profile.sessions.revoke": "Revoke session",
  "profile.sessions.revoke_error": "Could not revoke the session. Try again.",
  "profile.sessions.revoke_success": "The session has been revoked.",
  "profile.sessions.revoke_title": "Confirm session revocation",
  "profile.sessions.title": "Active sessions",
  "profile.sessions.unknown": "Unknown",
  "profile.sessions.user_agent": "Browser and device",
  "profile.staff.binding.title": "Link an employee mobile account",
  "profile.staff.binding.description": "Keep the App and admin accounts separate. Linking requires confirmation on both sides; email and phone numbers do not merge accounts.",
  "profile.staff.binding.unbind_confirm": "Unlinking stops mobile reception and revokes admin sessions created through this link. Continue?",
  "profile.staff.binding.unbind": "Unlink",
  "profile.staff.binding.add": "Link mobile account",
  "profile.staff.binding.hint": "Verify your employee identity, scan with the selected App, then confirm the mobile account here. The code expires in two minutes.",
  "profile.staff.binding.confirm": "Confirm this App account",
  "profile.staff.login.title": "Sign in with App QR code",
  "profile.staff.login.hint": "Open Scan in the AppKernia App, check the website and employee identity, then confirm.",
  "profile.staff.error": "Unable to complete the operation. Check permissions, verification, QR status, or connection and retry.",
  "profile.staff.app": "Employee mobile App",
  "profile.staff.verification": "Security verification",
  "profile.staff.password": "Admin password",
  "profile.staff.totp": "Authenticator code",
  "profile.staff.proof": "Verification code or password",
  "profile.staff.required": "Enter a valid value",
  "profile.staff.generate": "Generate QR code",
  "profile.staff.state.pending": "Waiting for App scan",
  "profile.staff.state.scanned": "Scanned; awaiting App confirmation",
  "profile.staff.state.approved": "Confirmed in App",
  "profile.staff.state.consumed": "Completed",
  "profile.staff.state.cancelled": "Cancelled",
  "profile.staff.state.expired": "QR code expired. Generate a new code.",
  "profile.staff.errors.step_up": "Use current security credentials. An authenticator code is required when TOTP is enabled.",
  "profile.staff.errors.conflict": "This code has been used or a binding conflicts. Check existing bindings and generate a new code.",
  "profile.staff.errors.rate_limit": "Too many attempts. Please try again later.",
  "profile.staff.errors.forbidden": "Your identity, application access or browser credentials are no longer valid. Sign in again.",
  "profile.staff.not_configured": "No employee App is configured. Ask the deployment administrator to configure the employee App allowlist.",
  "profile.staff.empty": "No mobile account linked",
  "profile.staff.refresh": "Refresh QR code",
  "profile.staff.account_login": "Account sign-in",
  "profile.staff.login.description": "Scan and confirm with your linked App account."
}
